import { Controller } from "@hotwired/stimulus"

// Reloads the advanced search page for the chosen borough so its facet option
// lists refresh, preserving the typed query.
export default class extends Controller {
  static values = { url: String }

  reload(event) {
    const form = event.target.closest("form")
    const query = form?.querySelector('[name="prism_works_search[query]"]')?.value || ""
    const params = new URLSearchParams({
      "prism_works_search[borough_id]": event.target.value,
      "prism_works_search[query]": query
    })
    window.location.assign(`${this.urlValue}?${params}`)
  }
}
